export enum DynamicButtons
{
  LOGIN    = 'login',
  USR_STEP = 'usrStep',
  PWD_STEP = 'pwdStep',
}
